// @ts-nocheck
import * as actions from '../../action-types';
import * as mutations from '../../mutation-types';
import axios from 'axios';
import { buildQuery } from '@/utils/url';
import utils from '@/app/utils/utils';

export default {
  [actions.SET_ERROR_PAGE_DATA]: ({ commit }, options) => {
    commit(mutations.SET_ERROR_PAGE_DATA, options);
  },
  [actions.FETCH_LOCATION_SUGGESTIONS]: async ({ commit, dispatch }, searchTerm) => {
    const paramsObj = { searchTerm };

    // Postal code length = 5 and listing id length = 6
    if (utils.isNumberParseable(searchTerm) && searchTerm.length < 7) {
      // Assume number under 6 digits should search for postal codes
      if (searchTerm.length < 6) {
        await dispatch(actions.FETCH_POSTAL_CODE_SUGGESTIONS, searchTerm);
        return Promise.resolve();
      }
      // Otherwise search for listings
      else {
        return axios
          .get(`/api/listing/${searchTerm}`)
          .then((result) => {
            commit(mutations.FOUND_LISTING, result.data);
            return Promise.resolve();
          })
          .catch((error) => {
            const errorCode = utils.getErrorCode(error);
            if (errorCode === 404) {
              commit(mutations.NO_LISTING_FOUND);
              return Promise.resolve();
            } else {
              return Promise.reject({ code: errorCode });
            }
          });
      }
    } else {
      return axios
        .get(`/api/regions/search?${buildQuery(paramsObj)}`)
        .then((result) => {
          commit(mutations.UNSET_AUTOCOMPLETE_ERROR);
          commit(mutations.SET_LOCATION_SUGGESTIONS, result.data);
        })
        .catch((error) => {
          commit(mutations.SET_AUTOCOMPLETE_ERROR);
          void Promise.reject({ code: utils.getErrorCode(error) });
        });
    }
  },
};
